import { useMemo } from 'react'

import { getYear, isWithinInterval, parseISO } from 'date-fns'

import { getYearMonthDayLocaleByDate } from '../../../../common/utils/utils'
import { useGetUtilizationQuartersQuery } from '../../../clients/clientDetails/data/utilizationApi'
import { PEMetric, PEMetrics } from '../data/platformEngagementApi'

type PEMetricsTransformed = {
  ytd: PEMetric
  quarters: { [key: string]: PEMetric }
  isEmpty: boolean
}
const useTransformPEMetrics = (
  peMetrics: PEMetrics | undefined,
  previousYear: boolean = false,
): PEMetricsTransformed | undefined => {
  const { data: utilizationQuarters } = useGetUtilizationQuartersQuery({
    date: getYearMonthDayLocaleByDate(
      previousYear ? new Date(getYear(new Date()) - 1, 11) : new Date(getYear(new Date()), 11),
    ),
  })
  return useMemo(() => {
    if (!peMetrics) {
      return undefined
    }
    const { ytd, ...quarters } = peMetrics
    const newQuarters: PEMetricsTransformed['quarters'] = {}

    for (const [name, metric] of Object.entries(quarters)) {
      const date = parseISO(name)
      const newKey =
        utilizationQuarters &&
        Object.keys(utilizationQuarters)
          .find((quarter) => {
            const [start, end] = utilizationQuarters[quarter]
            return isWithinInterval(date, {
              start: parseISO(start),
              end: parseISO(end),
            })
          })
          ?.replace('_', ' ')
      if (newKey) {
        newQuarters[newKey] = metric
      }
    }

    return {
      ytd,
      quarters: newQuarters,
      isEmpty: ytd.assignment_rate === null && ytd.feedback_rate === null && ytd.engagement_rate === null,
    }
  }, [peMetrics, utilizationQuarters])
}

export default useTransformPEMetrics
